import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getNihClinGenVariantsData } from "../../../../state/selectors/NihClinGenVariants.selectors";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";
import { DEFAULT_COLOR } from "../../../../common/helpers/helpers";

const ClinGenCard = ({ card, nihClinGenVariantsData }) => {
  const isDisabled =
    !nihClinGenVariantsData ||
    !Object.keys(nihClinGenVariantsData[0] || {}).length;

  const calcColor = () => {
    let color = DEFAULT_COLOR;
    if (nihClinGenVariantsData && nihClinGenVariantsData.length > 0) {
      color = getPathogenicityColorByAllNames(
        nihClinGenVariantsData[0].pathogenicity
      );
    }
    return color;
  };

  const renderPathogenicity = () => {
    if (nihClinGenVariantsData && nihClinGenVariantsData.length > 0) {
      return (
        <span style={{ color: calcColor() }}>
          <b data-testid="clingen-pathogenicity">
            {nihClinGenVariantsData[0].pathogenicity}
          </b>
        </span>
      );
    }
    return null;
  };

  return (
    <CardWrapper
      {...card}
      isDisabled={isDisabled}
      color={calcColor()}
      secondaryTitle={renderPathogenicity()}
    >
      <div>
        <div>
          <div>
            {"Expert Panel: "}
            <span className="tw-font-bold" data-testid="clingen-panel-data">
              {nihClinGenVariantsData &&
                nihClinGenVariantsData.length > 0 &&
                nihClinGenVariantsData[0].expert_panel}
            </span>
          </div>
        </div>
      </div>
    </CardWrapper>
  );
};

ClinGenCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  nihClinGenVariantsData: PropTypes.arrayOf(
    PropTypes.shape({
      pathogenicity: PropTypes.string,
      expert_panel: PropTypes.string,
    })
  ),
};

ClinGenCard.defaultProps = {
  nihClinGenVariantsData: [],
};

const mapStateToProps = (state) => ({
  nihClinGenVariantsData: getNihClinGenVariantsData(state),
});

export default connect(mapStateToProps)(ClinGenCard);
